import { useContext } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { calculatePromoCode, calculateTax, calculateTaxPrecent, getSubTotalPricing } from '@/utils/pricing';
import { useTranslate } from '@/hooks/useTranslate';
import { cn } from '@/utils/cn';
import { Templates } from '@/types/common';

export const PriceDetails = () => {
  const { pricing, boot, template } = useContext(CheckoutContext);
  const isOnePayment = template.type === Templates.OnePayment;
  const { t } = useTranslate();

  const showDiscount = Boolean(pricing.priceBreakdown.discount);
  const isTaxValid = pricing.priceBreakdown.isTaxValid;
  const discountRatePoints = pricing.priceBreakdown.discountRatePoints ?? 0;
  return (
    <div
      className={cn(`flex flex-col gap-2 text-sm`, isOnePayment && 'text-card-foreground')}
      style={{
        color: !isOnePayment ? boot?.checkoutTheme?.textColor : undefined,
      }}
    >
      <div className="flex justify-between">
        <div>{t('subtotal')}</div>
        <div>{getSubTotalPricing(pricing.priceBreakdown, pricing)}</div>
      </div>
      {showDiscount && (
        <div className="flex justify-between">
          <div>
            {t('discount')}
            {discountRatePoints ? ` (${discountRatePoints}%)` : ''}
          </div>
          <div>{calculatePromoCode(pricing.priceBreakdown, pricing)}</div>
        </div>
      )}
      <div className="flex justify-between">
        <div>
          {t('tax')}
          {isTaxValid ? ` (${calculateTaxPrecent(pricing.priceBreakdown)})` : ''}
        </div>
        <div>{calculateTax(pricing.priceBreakdown, pricing)}</div>
      </div>
    </div>
  );
};
